export const messages = {
  en: {
    supplierCouponBuy: {
      searchTitle: 'Query Conditions',
      listTitle: 'Coupon Purchase Records',
      placeholder: {
        buyId: 'Order Number',
        couponId: 'Coupon ID',
        name: 'Name',
        supplierName: 'Supplier',
        storeName: 'Store Name',
        objName: 'Community Name',
        createUserTel: 'Contact Info',
        createUserName: 'Buyer'
      },
      table: {
        buyId: 'ID',
        couponName: 'Coupon',
        name: 'Name',
        supplierName: 'Supplier',
        quantity: 'Quantity',
        valuePrice: 'Price',
        storeName: 'Store Name',
        objName: 'Community Name',
        createUserTel: 'Contact',
        createUserName: 'Buyer',
        remark: 'Remark'
      },
      fetchError: 'Failed to fetch coupon purchase records',
      page: {
        subtitle: 'Review coupon purchase records across suppliers and stores',
        empty: 'No coupon purchase record data',
        loadFailed: 'Failed to load coupon purchase record list'
      }
    }
  },
  zh: {
    supplierCouponBuy: {
      searchTitle: '查询条件',
      listTitle: '优惠券购买记录',
      placeholder: {
        buyId: '请填写订单号',
        couponId: '请填写优惠券编号',
        name: '请填写名称',
        supplierName: '请填写供应商',
        storeName: '请填写商户名称',
        objName: '请填写小区名称',
        createUserTel: '请填写联系方式',
        createUserName: '请填写购买人'
      },
      table: {
        buyId: '编号',
        couponName: '优惠券',
        name: '名称',
        supplierName: '供应商',
        quantity: '购买数量',
        valuePrice: '售价',
        storeName: '商户名称',
        objName: '小区名称',
        createUserTel: '联系方式',
        createUserName: '购买人',
        remark: '备注'
      },
      fetchError: '获取优惠券购买记录失败',
      page: {
        subtitle: '查看各供应商与门店的优惠券购买记录',
        empty: '暂无优惠券购买记录数据',
        loadFailed: '获取优惠券购买记录列表失败'
      }
    }
  }
}